import React, { useState } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { useNotifications } from '../../context/NotificationsContext';

// Generic three-dots actions menu for a notification item
// Props: notification (object), align ("right" | "left") optional
const NotificationActionsMenu = ({ notification, align = 'right', className = '' }) => {
  const { markAsRead, markAsUnread, deleteNotification } = useNotifications();
  const [open, setOpen] = useState(false);

  if (!notification) return null;

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen(o => !o);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    deleteNotification(notification.id);
    setOpen(false);
  };

  const handleMarkReadUnread = (e) => {
    e.stopPropagation();
    if (notification.read) {
      markAsUnread(notification.id);
    } else {
      markAsRead(notification.id);
    }
    setOpen(false);
  };

  return (
    <div className={"relative inline-block text-left " + className}>
      <button
        type="button"
        onClick={handleToggle}
        className="p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none"
        aria-haspopup="true"
        aria-expanded={open}
      >
        <BsThreeDots />
      </button>
      {open && (
        <div
          className={`absolute z-20 mt-2 w-44 origin-top-${align} rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black/5 focus:outline-none ${align === 'right' ? 'right-0' : 'left-0'}`}
          role="menu"
        >
          <div className="py-1" role="none">
            <button
              onClick={handleMarkReadUnread}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
              role="menuitem"
            >
              {notification.read ? 'Mark as Unread' : 'Mark as Read'}
            </button>
            <button
              onClick={handleDelete}
              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30"
              role="menuitem"
            >
              Delete Notification
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationActionsMenu;
